import React, { useEffect, useState } from "react";
import main_page_img from "../Images/public/Homepage_Image.jpeg";
import main_page_img1 from "../Images/public/main_page_img1.jpg";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { NumToFa, convertToPersian, RangeToFa } from "../Functions/TextTransform";

import { baseURLGetSliderWithKey, imgUrl } from "../config/api";
function Home() {
  const [index, setIndex] = useState(0);
  const [index2, setIndex2] = useState(0);
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const [slide, setSlide] = useState([]);
  const [slideList, setSlideList] = useState([]);
  const [slideList2, setSlideList2] = useState([]);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const handleSelect2 = (selectedIndex, e) => {
    setIndex2(selectedIndex);
  };

  function getslide() {
    axios
      .get(baseURLGetSliderWithKey)
      .then((response) => {
        let arr = response.data;
        setSlide(arr.slide);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function renderSlide() {
    const slideLists = [];
    const slideLists2 = [];
    let promiseArr = [];
    for (let i = 0; i < slide.length; i++) {
      promiseArr[i] = new Promise((resolve, reject) => {
        let url = slide[i].url;
        let text1EN = slide[i].text1EN;
        let text2EN = slide[i].text2EN;
        let text1 = slide[i].text1;
        let text2 = slide[i].text2;

        slideLists.push(
          <Carousel.Item
            interval={4500}
            key={"slide" + i}
            slide_id={i}
            className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          >
            <img
              src={
                url === undefined || url === null || url === ""
                  ? `${process.env.PUBLIC_URL}/no_image.svg`
                  : imgUrl(url)
              }
              className={`img-fluid img-fluid-desktop ${
                pageLanguage === "fa" ? "font_farsi" : "font_en"
              }`}
              alt=""
            />
            <Carousel.Caption
              className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
            >
              <h3 
              style={{color:"white"}}
              className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
                {pageLanguage === "en" ? text1EN : convertToPersian(text1)}
              </h3>
              <p
              style={{color:"white"}}
              className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
                {pageLanguage === "en" ? text2EN : convertToPersian(text2)}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        );
        slideLists2.push(
          <Carousel.Item
            interval={null}
            key={"slide2" + i}
            slide_id={i}
            className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          >
            <img
              src={
                url === undefined || url === null || url === ""
                  ? `${process.env.PUBLIC_URL}/no_image.svg`
                  : imgUrl(url)
              }
              className={`img-fluid ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
              alt=""
            />
            <Carousel.Caption
              className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
            >
              <h3 className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
                {pageLanguage === "en" ? text1EN : convertToPersian(text1)}
              </h3>
              <p className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
                {pageLanguage === "en" ? text2EN : convertToPersian(text2)}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        );
        resolve();
      });
    }
    Promise.all(promiseArr).then(() => {
      setSlideList(slideLists);
      setSlideList2(slideLists2);
    });
    // console.log(slideLists)
  }

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
      setSlideList([]);
    }
    // setIndex(1);
  }, [location.pathname]);

  useEffect(() => {
    if (pageLanguage !== "") {
      setTimeout(() => {
        getslide();
      }, 200);
    }
  }, [pageLanguage]);

  useEffect(() => {
    if (slide.length) {
      renderSlide();
    }
  }, [slide]);

  // useEffect(() => {
  //     getslide();
  // }, []);

  return (
    <div className="main_page_mid">
      <div className="col-lg-12">
        <div className="main_page_slide_show desktop_only">
          <Carousel activeIndex={index} onSelect={handleSelect} variant="dark" pause="false">
            {slideList}
          </Carousel>
        </div>
        <div className="main_page_slide_show mobile_only">
          <Carousel
            interval={null}
            activeIndex={index2}
            onSelect={handleSelect2}
            variant="dark"
            controls={false}
          >
            {slideList2}
          </Carousel>
        </div>
      </div>
    </div>
  );
}

export default Home;
